import { render, staticRenderFns } from "./SpecialtieModal.vue?vue&type=template&id=49cc4ef4&"
import script from "./SpecialtieModal.vue?vue&type=script&lang=js&"
export * from "./SpecialtieModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports